// import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import { toUri } from '../../helpers.js'

export default class LayerPlaces {
  constructor (name, map, before = null) {
    this.name = name
    this.map = map
    this.layer = `${this.name}-markers`
    this.before = before
  }

  create () {
    fetch(`${window.SITE_BASE}/places.json`)
      .then(response => response.json())
      .then(data => {
        let { geojson } = data
        if (geojson) {
          this.map.addSource('site-places', {
            type: 'geojson',
            data: geojson,
            cluster: false,
          })

          const layerOptions = {
            id: this.layer,
            type: 'symbol',
            source: this.name,
            layout: {
              'icon-image': 'place-marker_tan_50',
              'icon-size': 1,
              // 'icon-allow-overlap': true,
              // 'icon-ignore-placement': true,
            }
          }
      
          // Add layer before another layer if specified
          if (this.before && this.map.getLayer(this.before)) {
            this.map.addLayer(layerOptions, this.before)
          } else {
            this.map.addLayer(layerOptions)
          }

          this.handleInitialLoad()
        }
      })
  }

  hide () {
    if (this.map.getLayer(this.layer) && this.map.getLayoutProperty(this.layer, 'visibility') !== 'none') {
      this.map.setLayoutProperty(this.layer, 'visibility', 'none');
    }
  }

  show () {
    if (this.map.getLayer(this.layer) && this.map.getLayoutProperty(this.layer, 'visibility') !== 'visible') {
      this.map.setLayoutProperty(this.layer, 'visibility', 'visible');
    }
  }

  handleInitialLoad () {
    const uri = toUri(window.GPLA_APP.state.location)
    if (uri.startsWith('guides')) {
      this.hide()
    }
  }
}